var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74996 2.41879L9.14996 4.81879M0.75 10.8188L3.66066 10.2323C3.81517 10.2012 3.95705 10.1251 4.06848 10.0136L10.5843 3.49425C10.8967 3.18168 10.8964 2.67502 10.5838 2.36271L9.20351 0.983995C8.89098 0.671816 8.38457 0.672029 8.0723 0.98447L1.55584 7.5045C1.44463 7.61577 1.3687 7.75736 1.33754 7.91156L0.75 10.8188Z",
    stroke: "#46597A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateNew);
export default __webpack_public_path__ + "static/media/Update_new.51382ad171c2b857515970127c1c66f1.svg";
export { ForwardRef as ReactComponent };